var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scrap-step-wrap" }, [
    _vm.formDataStep2.length > 0
      ? _c("div", { staticClass: "go-modal-inner" }, [
          _c("div", { staticClass: "scrap-step-contents" }, [
            _c("ol", { staticClass: "scrap-agent-register-header" }, [
              _c("li", [
                _vm._v(
                  _vm._s(_vm.$t("scrap-agent.register-table.channel-name"))
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("scrap-agent.register-table.account"))),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  _vm._s(_vm.$t("scrap-agent.register-table.allow-access"))
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("scrap-agent.register-table.to-use"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "scrap-agent-register-body" },
              [
                _c(
                  "vue-custom-scrollbar",
                  {
                    staticClass:
                      "go-list-inner customScroll csScrollPosition ps listWrapBoxMyReport",
                    attrs: { settings: _vm.scrollSettings },
                  },
                  _vm._l(_vm.formDataStep2, function (item, index) {
                    return _c("div", { key: index }, [
                      _c(
                        "ul",
                        [
                          _c("li", [
                            _c("img", {
                              staticClass: "mCS_img_loaded",
                              attrs: {
                                src: item.channelImageUri,
                                alt: "Naver blog",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.channelName))]),
                          ]),
                          _vm._v(" "),
                          item.accounts && item.accounts.length > 0
                            ? [
                                _vm._l(
                                  item.accounts,
                                  function (account, accIndex) {
                                    return [
                                      _c(
                                        "li",
                                        {
                                          key: "_" + accIndex,
                                          staticClass: "d-flex",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.truncateText(
                                                account.accountName
                                              ) || ""
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("li", {
                                        key: "1_" + accIndex,
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.getDataSource(
                                              account.dataSource
                                            )
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("li", { key: "2_" + accIndex }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "custom-control custom-switch",
                                          },
                                          [
                                            _c("input", {
                                              staticClass:
                                                "custom-control-input",
                                              attrs: {
                                                type: "checkbox",
                                                id: _vm.getUniqueId(
                                                  account,
                                                  item.channelId,
                                                  index,
                                                  accIndex
                                                ),
                                              },
                                              domProps: {
                                                checked: account.isScrap,
                                              },
                                              on: {
                                                change: function () {
                                                  return _vm.changeStatus(
                                                    item,
                                                    accIndex,
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("label", {
                                              staticClass:
                                                "custom-control-label",
                                              attrs: {
                                                for: _vm.getUniqueId(
                                                  account,
                                                  item.channelId,
                                                  index,
                                                  accIndex
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  }
                                ),
                              ]
                            : item.accounts && item.accounts.length === 0
                            ? [
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      (item.accounts[0] &&
                                        _vm.truncateText(
                                          item.accounts[0].accountName
                                        )) ||
                                        ""
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getDataSource(
                                        item.accounts[0] &&
                                          item.accounts[0].dataSource
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-switch",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "checkbox",
                                          id: _vm.getUniqueId(
                                            {},
                                            item.channelId,
                                            index,
                                            0
                                          ),
                                        },
                                        domProps: { checked: false },
                                        on: {
                                          change: function () {
                                            return _vm.changeStatus(
                                              item,
                                              0,
                                              index
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        staticClass: "custom-control-label",
                                        attrs: {
                                          for: _vm.getUniqueId(
                                            {},
                                            item.channelId,
                                            index,
                                            0
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ])
                  }),
                  0
                ),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.formDataStep2.length == 0
      ? _c(
          "div",
          {
            staticClass: "go-modal-inner",
            staticStyle: { overflow: "visible" },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "mCustomScrollBox mCS-minimal-dark mCSB_vertical mCSB_outside",
                staticStyle: { "max-height": "none" },
                attrs: { tabindex: "0" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "mCSB_container mCS_y_hidden mCS_no_scrollbar_y",
                    staticStyle: { position: "relative", top: "0", left: "0" },
                    attrs: { id: "mCSB_3_container", dir: "ltr" },
                  },
                  [
                    _c("div", { staticClass: "go-no-data" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-default",
                          attrs: { type: "button" },
                          on: { click: _vm.openModalRegister },
                        },
                        [
                          _c("i", { staticClass: "go-icon-18 go-icon-plus" }),
                          _vm._v(" "),
                          _c("em", { staticClass: "go-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "scrap-agent.register-table.register-channel"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("You are not having any channels right now."),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm._m(1),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dfn", [
      _vm._v(" Click the "),
      _c("b", [_vm._v("Add Channel")]),
      _vm._v(" button above to register the desired channel. "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "mCSB_scrollTools mCSB_3_scrollbar mCS-minimal-dark mCSB_scrollTools_vertical",
        staticStyle: { display: "none" },
        attrs: { id: "mCSB_3_scrollbar_vertical" },
      },
      [
        _c("div", { staticClass: "mCSB_draggerContainer" }, [
          _c(
            "div",
            {
              staticClass: "mCSB_dragger",
              staticStyle: {
                position: "absolute",
                "min-height": "50px",
                height: "0px",
                top: "0px",
              },
              attrs: { id: "mCSB_3_dragger_vertical" },
            },
            [
              _c("div", {
                staticClass: "mCSB_dragger_bar",
                staticStyle: { "line-height": "50px" },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mCSB_draggerRail" }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }